import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Shield, Heart, CheckCircle, MessageCircle } from "lucide-react";
import { InterviewDialog } from "@/components/InterviewDialog";
const Hero = () => {
  const [isInterviewOpen, setIsInterviewOpen] = useState(false);
  
  return (
    <>
      <section className="hero-section">
      <div className="hero-container">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="hero-heading text-balance">
            Machen Sie Ihre Immobilie zu Ihrer
            <span className="text-accent block mt-2">
              finanziellen Sicherheit
            </span>
          </h2>
          
          <p className="hero-lcp-text">
            Entdecken Sie 6 bewährte Wege, wie Sie das in Ihrer Immobilie 
            gebundene Kapital für Ihren Lebensabend nutzen können – 
            mit unserer kostenlosen und unabhängigen Beratung.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button variant="accent" size="lg" className="text-lg md:text-xl px-8 md:px-12 py-4 leading-tight shadow-[0_0_20px_hsl(var(--accent)/0.3)] hover:shadow-[0_0_30px_hsl(var(--accent)/0.4)]" onClick={() => document.getElementById('advisor-wizard')?.scrollIntoView({
            behavior: 'smooth'
          })}>
              <span className="text-center">
                Hier kostenlosen digitalen<br className="md:hidden" />
                <span className="hidden md:inline"> </span>Berater starten
              </span>
            </Button>
            
            <Button 
              variant="outline" 
              size="lg" 
              className="text-lg md:text-xl px-8 md:px-12 py-4 leading-tight shadow-[0_0_20px_hsl(var(--accent)/0.2)] hover:shadow-[0_0_30px_hsl(var(--accent)/0.3)] transition-all"
              onClick={() => setIsInterviewOpen(true)}
            >
              <MessageCircle className="mr-2 h-5 w-5" />
              <span className="text-center">
                Interview mit<br className="md:hidden" />
                <span className="hidden md:inline"> </span>den Gründern
              </span>
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-3xl mx-auto">
            <div className="flex flex-col items-center text-center p-4">
              <div className="bg-accent/10 p-4 rounded-xl mb-4">
                <Shield className="h-8 w-8 text-accent" />
              </div>
              <h3 className="text-xl font-semibold text-primary mb-2">
                100% Kostenlos
              </h3>
              <p className="text-muted-foreground">
                Unsere Beratung ist völlig 
                kostenfrei und unverbindlich
              </p>
            </div>

            <div className="flex flex-col items-center text-center p-4">
              <div className="bg-accent/10 p-4 rounded-xl mb-4">
                <Heart className="h-8 w-8 text-accent" />
              </div>
              <h3 className="text-xl font-semibold text-primary mb-2">
                Vertrauensvoll
              </h3>
              <p className="text-muted-foreground">
                Über 8.000 zufriedene Senioren
                vertrauen bereits auf unsere Beratung
              </p>
            </div>

            <div className="flex flex-col items-center text-center p-4">
              <div className="bg-accent/10 p-4 rounded-xl mb-4">
                <CheckCircle className="h-8 w-8 text-accent" />
              </div>
              <h3 className="text-xl font-semibold text-primary mb-2">
                Unabhängig
              </h3>
              <p className="text-muted-foreground">
                Objektive Beratung ohne 
                versteckte Kosten oder Provisionen
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <InterviewDialog 
      open={isInterviewOpen} 
      onOpenChange={setIsInterviewOpen}
    />
    </>);
};
export default Hero;